import api from './wasteManagementClient';
import { wasteManagementUrls as urls } from '../appConfig';
import {
  IGenericMapAction,
  IGenericMapActionType,
  IGenericMapExecutedAction,
} from '../models/SmartMapActions.model';

export abstract class SmartMapActionsService {
  public static async getActionTypes(
    ignoreCache = false
  ): Promise<Array<IGenericMapActionType>> {
    try {
      const params = { cache: { ignoreCache } };
      const response = await api.get(urls.genericMapActions + '/types', params);
      return response.status === 200 ? response.data : [];
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async getActionByTypeId(
    typeId: number,
    ignoreCache = false
  ): Promise<IGenericMapAction> {
    try {
      const params = { params: { typeId }, cache: { ignoreCache } };
      const response = await api.get(urls.genericMapActions, params);
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async executeAction(
    executedAction: IGenericMapExecutedAction
  ): Promise<IGenericMapExecutedAction> {
    try {
      const response = await api.post(urls.genericMapActions, executedAction);
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }
}
